"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var storybook_2 = require("@eyecons/storybook");
var Body = function (_a) {
    var children = _a.children;
    return react_1.default.createElement("div", { className: 'storybook-menus-dashboard-sidebar-body' }, children);
};
var Close = function (_a) {
    var onClick = _a.onClick;
    return react_1.default.createElement("button", { onClick: onClick },
        react_1.default.createElement(storybook_2.Icons.Icon, { name: 'x', className: 'w-6' }));
};
var Container = function (_a) {
    var children = _a.children, align = _a.align;
    var alignClass = align ? 'storybook-menus-dashboard-sidebar-container-' + align : '';
    return react_1.default.createElement("div", { className: "storybook-menus-dashboard-sidebar-container " + alignClass },
        react_1.default.createElement("div", null, children));
};
var Header = function (_a) {
    var children = _a.children;
    return react_1.default.createElement("div", { className: 'storybook-menus-dashboard-sidebar-header' }, children);
};
var Overlay = function (_a) {
    var open = _a.open, children = _a.children, onClose = _a.onClose;
    return react_1.default.createElement("div", { className: open ? 'storybook-menus-dashboard-sidebar-overlay-open' : 'storybook-menus-dashboard-sidebar-overlay-close' },
        children,
        react_1.default.createElement("div", { className: 'storybook-menus-dashboard-sidebar-overlay-1', onClick: onClose }));
};
var Title = function (_a) {
    var children = _a.children;
    return react_1.default.createElement("h2", { className: 'storybook-menus-dashboard-sidebar-title' }, children);
};
var Sidebar = function (_a) {
    var hamburgerClassName = _a.hamburgerClassName, user = _a.user, channel = _a.channel, items = _a.items;
    var _b = react_1.useState(false), sidebarOpen = _b[0], setSidebarOpen = _b[1];
    var permissions = user.permissions;
    return react_1.default.createElement("div", { className: 'storybook-menus-dashboard-sidebar' },
        react_1.default.createElement(storybook_1.Menus.Dashboard.Hamburger, { className: hamburgerClassName, onClick: function () { return setSidebarOpen(!sidebarOpen); }, open: sidebarOpen }),
        react_1.default.createElement(Overlay, { open: sidebarOpen, onClose: function () { return setSidebarOpen(!sidebarOpen); } },
            react_1.default.createElement(Container, null,
                react_1.default.createElement(Header, null,
                    react_1.default.createElement(Close, { onClick: function () {
                            setSidebarOpen(!sidebarOpen);
                        } })),
                react_1.default.createElement(Body, null, items.map(function (item, index) {
                    var child_items = item.items.filter(function (item) { return !(item.admin && !permissions.includes(item.permission)); });
                    if (child_items.length) {
                        return react_1.default.createElement("div", { key: index },
                            react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3' }, item.label),
                            react_1.default.createElement("div", { className: 'storybook-menus-dashboard-sidebar-items' }, child_items
                                .map(function (child_item, child_item_index) {
                                return react_1.default.createElement("div", { key: child_item_index, className: 'storybook-menus-dashboard-sidebar-item' },
                                    react_1.default.createElement(storybook_1.Texts.Link, { href: child_item.url, disabled: !permissions.includes(child_item.permission) }, child_item.label),
                                    child_item.pro && channel.role !== 'pro' &&
                                        react_1.default.createElement(storybook_1.Texts.Link, { href: process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/pro" },
                                            react_1.default.createElement(storybook_1.Texts.Badge, { type: 'secondary' }, "PRO")));
                            })));
                    }
                })))));
};
exports.Sidebar = Sidebar;
